import { render } from "./ConfirmReset.vue?vue&type=template&id=04cd8366&scoped=true"
import script from "./ConfirmReset.vue?vue&type=script&lang=js"
export * from "./ConfirmReset.vue?vue&type=script&lang=js"

import "./ConfirmReset.vue?vue&type=style&index=0&id=04cd8366&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\sonic\\renault\\new_resources\\renault_configurator\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04cd8366"]])

export default __exports__